window.GLOBAL_AHKAHSHOPS = window.GLOBAL_AHKAHSHOPS || {};
GLOBAL_AHKAHSHOPS.StoresMap = {
  mapObj: null,
  marker: [],
  infoWindow: [],
  displayId: "storesMap",//マップを表示する要素ID
  currentLocationBtn: "#currentLocation",// 現在地表示ボタンの要素
  storeListSelector: ".js-shops-name",// 店舗タイプの要素
  typeName: ".js-shop-category",// 店舗タイプ
  defaultMapCenter: { lat: 35.6600, lng: 139.7350 },//現在地オフの場合のマップ位置
  styleOptions: [
    {
      "elementType": "geometry",
      "stylers": [{ "color": "#EEEEEE" }]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#808080" }]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#ffffff" }]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [{ "color": "#DDDDDD" }]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{ "color": "#DDDDDD" }]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{ "color": "#DDDDDD" }]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#F6F6F6" }]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#808080" }]
    },
    {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [{ "color": "#E5E5E5" }]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{ "color": "#E5E5E5" }]
    },
    {
      "elementType": "labels.icon",
      "stylers": [{ "visibility": "off" }]
    }
  ],
  markerArray: [],// マーカーインスタンス格納用配列
};

//マーカー画像のパス
GLOBAL_AHKAHSHOPS.StoresMap.icons = {
  direct: "//www.ahkah.com/cdn/shop/t/3/assets/marker_direct.svg?v=30599557030485696591745388514",// 直営店
  official: "//www.ahkah.com/cdn/shop/t/3/assets/marker_official.svg?v=74417102366252769331745388520",// 正規代理店
}

// 店舗ごとの位置・店舗名・店舗タイプの情報を配列に格納
function setStoreMapDataArray(){
  // マーカーを立てる場所名・緯度・経度
  const markerDataArray = [];
  //表示されている店舗のみ処理
  $(".js-listbox").filter(function() {
    return $(this).css('display') !== 'none';
  }).each(function(){
    //DOMから店舗名・店舗タイプ・経度・緯度を取得
    const dataName = $(this).find(GLOBAL_AHKAHSHOPS.StoresMap.storeListSelector).text().trim();
    const dateType = $(this).find(GLOBAL_AHKAHSHOPS.StoresMap.typeName).text().trim();
    //経度・緯度は、文字列を数値（少数点以下もそのまま残す）に変換
    const StrLat = parseFloat($(this).find(".js-mapstor-lat").text().trim());
    const StrLng = parseFloat($(this).find(".js-mapstor-lng").text().trim());

    //各店舗の情報を一つの配列にまとめる
    markerDataArray.push({
      markerDataName: dataName,
      markerDataType: dateType,
      markerDataLat: StrLat,
      markerDataLng: StrLng

    });
  });
  return markerDataArray;
}

// Googleマップの作成
function initializeStoreMap(markerData, callback){
  // マップの中心となる緯度・経度を変数に格納
  const centerLat = 34.1737161;
  const centerLng = 129.6389727;
  const mapLatLng = new google.maps.LatLng(centerLat,centerLng);

  // マップオプションを変数に格納
  const mapOptions = {
    zoom : 4,          // 拡大倍率(小数は×)
    center : mapLatLng,  // 緯度・経度
    mapTypeControl: false // 地図タイプ コントロールを非表示にする
  };

  // マップオブジェクト作成
  GLOBAL_AHKAHSHOPS.StoresMap.mapObj = new google.maps.Map(
    document.getElementById(GLOBAL_AHKAHSHOPS.StoresMap.displayId), // マップを表示する要素
    mapOptions // マップオプション
  );

  // マップのスタイル設定
  const styledMapOptions = { name: "AHKAH map style" }
  const storeMapType = new google.maps.StyledMapType(GLOBAL_AHKAHSHOPS.StoresMap.styleOptions, styledMapOptions);
  const customMapTypeId = 'custom_style';
  GLOBAL_AHKAHSHOPS.StoresMap.mapObj.mapTypes.set(customMapTypeId, storeMapType);
  GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setMapTypeId(customMapTypeId);

  // マーカーの設置
  setStoreMapMarker(markerData);

  // 店舗位置にズーム
  setupStoreMapCenter(markerData);

  // 完了後に callback 実行
  if (typeof callback === 'function') {
    callback();
  }
  
}

// 現在地取得処理とマップ初期化
function initMap(callback) {
  //店舗の緯度・経度を配列に格納
  const markerData = setStoreMapDataArray();

  // Geolocation APIに対応している
  if (navigator.geolocation) {
    // Googleマップの作成
    initializeStoreMap(markerData, callback);

    navigator.geolocation.getCurrentPosition(
      function(position) {
        //「残在地」ボタンを表示
        $(GLOBAL_AHKAHSHOPS.StoresMap.currentLocationBtn).show();
        //「現在地」ボタンの処理
        const currentPositionLat = position.coords.latitude; //現在地の緯度
        const currentPositionLong = position.coords.longitude; //現在地の経度
        centerStoreMapCurrentLocation(currentPositionLat,currentPositionLong);
      },
      function(error) {
        // 現在地取得失敗時の対応
        switch(error.code) {
          case 1: // PERMISSION_DENIED
            alert("位置情報の利用が許可されていません");
            break;
          case 2: // POSITION_UNAVAILABLE
            alert("現在位置が取得できませんでした");
            break;
          case 3: // TIMEOUT
            alert("タイムアウトになりました");
            break;
          default:
            alert("その他のエラー(エラーコード:"+error.code+")");
            break;
        }
      },{
        enableHighAccuracy: false,// 現在地の精度が低いが、なるべく速く位置情報を返す
        maximumAge: 10000          // 10秒以内のキャッシュを許可      
      }
    );

  // Geolocation APIに対応していない
  } else {
    alert("この端末では位置情報が取得できません");
    // マーカーを設置
    setStoreMapMarker(markerData);
  }
}

// マーカーを設定
function setStoreMapMarker(markerData){
  let storesMapIconPath;
  // マーカー毎の処理
  for (let i = 0; i < markerData.length; i++) {
      // 緯度経度のデータ作成
      const markerLatLng = new google.maps.LatLng({
        lat: markerData[i]['markerDataLat'], 
        lng: markerData[i]['markerDataLng']
      });
      //直営店・正規代理店によってマーカー画像を分ける
      if(markerData[i]['markerDataType'].includes('直営店') || markerData[i]['markerDataType'].includes('グローバル')){
        storesMapIconPath = GLOBAL_AHKAHSHOPS.StoresMap.icons.direct;// 直営店のマーカー
      }else{
        storesMapIconPath = GLOBAL_AHKAHSHOPS.StoresMap.icons.official;// 正規代理店のマーカー
      }
      // マーカーの追加
      GLOBAL_AHKAHSHOPS.StoresMap.marker[i] = new google.maps.Marker({
        position: markerLatLng, // マーカーを立てる位置を指定
        map: GLOBAL_AHKAHSHOPS.StoresMap.mapObj, // マーカーを立てる地図を指定
        icon: storesMapIconPath//マーカー画像
      });
      GLOBAL_AHKAHSHOPS.StoresMap.infoWindow[i] = new google.maps.InfoWindow({
        // 吹き出しの追加
        content: '<div class="bubble">' + markerData[i]['markerDataName'] + '</div>' // 吹き出しに表示する内容
      });
      // マーカーにクリックイベントを追加
      addStoreMapMarkerEvent(i,markerData);
      //マーカーを順次格納
      GLOBAL_AHKAHSHOPS.StoresMap.markerArray.push(GLOBAL_AHKAHSHOPS.StoresMap.marker[i]);
  }
}

// マーカーにクリックイベントを追加
function addStoreMapMarkerEvent(i,markerData) {
  // マーカーをクリックしたとき
  GLOBAL_AHKAHSHOPS.StoresMap.marker[i].addListener('click', function() {
    // 吹き出しの表示
    GLOBAL_AHKAHSHOPS.StoresMap.infoWindow[i].open(GLOBAL_AHKAHSHOPS.StoresMap.mapObj, GLOBAL_AHKAHSHOPS.StoresMap.marker[i]); 
    //地図の位置座標を移動
    GLOBAL_AHKAHSHOPS.StoresMap.mapObj.panTo(new google.maps.LatLng(markerData[i]['markerDataLat'],markerData[i]['markerDataLng']));
    //ズームを変更
    GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setZoom(16);
    //店舗情報のポップアップ表示処理
    handleMarkerClickShowPopup(i,markerData);
  });
}

// 店舗位置にズーム
function setupStoreMapCenter(markerData){
	// クリックしたら中心にマップを移動
	$(GLOBAL_AHKAHSHOPS.StoresMap.storeListSelector).on("click",function(){
		const storesName = $(this).text();//店舗名
		changeStoreMapCenter(storesName,markerData);
	});
}

// クリックしたら中心にマップを移動
function changeStoreMapCenter(storesName,markerData) {
  $.each(markerData, function(index, markerDataValue) {
    if(markerDataValue.markerDataName == storesName){
      if(!markerData[index]['markerDataLat'] || !markerData[index]['markerDataLng']){
        return false;
      }
      //地図の位置座標を移動
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.panTo(new google.maps.LatLng(markerData[index]['markerDataLat'],markerData[index]['markerDataLng']));
      //ズームを変更
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setZoom(16);
    }
  });
}

//「現在地」ボタンの処理
function centerStoreMapCurrentLocation(currentPositionLat,currentPositionLong){
  // 現在地ボタンをクリック
  $(GLOBAL_AHKAHSHOPS.StoresMap.currentLocationBtn).on("click",function(){
    //東京周辺を表示
    if(!$(this).hasClass('is-disabled')){
      // 緯度経度のデータ作成
      const markerLatLng = new google.maps.LatLng(GLOBAL_AHKAHSHOPS.StoresMap.defaultMapCenter['lat'], GLOBAL_AHKAHSHOPS.StoresMap.defaultMapCenter['lng']);
      // 中心にマップを移動
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.panTo(markerLatLng);
      //ズームを変更
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setZoom(13);
      //オフのボタンに切り替え
      $(GLOBAL_AHKAHSHOPS.StoresMap.currentLocationBtn).addClass('is-disabled');

    //現在地を表示
    }else{
      // 緯度経度のデータ作成
      const markerLatLng = new google.maps.LatLng(currentPositionLat, currentPositionLong);
      // 中心にマップを移動
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.panTo(markerLatLng);
      //ズームを変更
      GLOBAL_AHKAHSHOPS.StoresMap.mapObj.setZoom(13);
      //オンのボタンに切り替え
      $(GLOBAL_AHKAHSHOPS.StoresMap.currentLocationBtn).removeClass('is-disabled');
    }
  });
}

// 全店舗のマーカーを削除
function deleteStoreMapMarker(){
  // マーカー毎の処理
  for (let i = 0; i < GLOBAL_AHKAHSHOPS.StoresMap.markerArray.length; i++) {
      GLOBAL_AHKAHSHOPS.StoresMap.markerArray[i].setMap(null);
  }
}

/*// 店舗ごとにマーカーを付ける(現在地表示されない場合)
function storesMarkerNoCurrent(markerData){
	const mapLatLng = new google.maps.LatLng({
    lat: markerData[0]['markerDataLat'],
    lng: markerData[0]['markerDataLng']
  }); // 緯度経度のデータ作成
	GLOBAL_AHKAHSHOPS.StoresMap.mapObj = new google.maps.Map(document.getElementById(GLOBAL_AHKAHSHOPS.StoresMap.displayId), { // #sampleに地図を埋め込む
    center: mapLatLng, // 地図の中心を指定
    zoom: 4 // 地図のズームを指定
  });

  // 店舗ごとにマーカーを付ける
  setStoreMapMarker(markerData);
}*/
